// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__Ujxyk","containerItemsCenter":"Skeleton_containerItemsCenter__1MhXv"};